import { Toast } from 'vant'

const productionPlan = {
  state: () => ({
    allData: {
      kitchen_code: '',
      kitchen_name: '',
      skuList: [],
      process_list: []
    },
    kitchenData:[],
    skuName: '',
    kitchenName: '',
    testContent: {
      kitchen_code:'',
      sku_ids:[]
    },
    kitchenSkuList:[],
    productionMethod: '',
    storeInfo: {
      store_id: '',
      store_name: ''
    },
  }),
  getters: {
    getAllData: state => state.allData,
    getKitchenData: state=>state.kitchenData,
    getSkuName: state=>state.skuName,
    getKitchenName: state=>state.kitchenName,
    getTestContent: state=>state.testContent,
    getkitchenSkuList: state=>state.kitchenSkuList,
    getProductionMethod: state=>state.productionMethod,
    getStoreInfo: state=>state.storeInfo
  },
  actions: {
    setAllData({state}, data) {
      state.allData = data
    },
    setKitchenData({state}, data) {
      state.kitchenData = data
    },
    setSkuName({state}, data) {
      state.skuName = data
    },
    setKitchenName({state}, data) {
      state.kitchenName = data
    },
    setTestContent({state}, data) {
      state.testContent = data
    },
    setkitchenSkuList({state}, data) {
      state.kitchenSkuList = data
    },
    //出品方式
    setProductionMethod({state}, data) {
      state.productionMethod = data
    },
    //选择门店
    setStoreInfo({state}, data) {
      state.storeInfo = data
    },
  },
}

export default productionPlan
